import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const ProfilePage = leadLazyLoad(
  () => import('./ProfilePage'),
  module => module.ProfilePage,
  { fallback: null, type: LeadPageType.PROFILE },
);
